import {
  initialState,
  Actions,
  State,
  EDIT_JUDICIAL,
  EDIT_JUDICIAL_SUCCESS,
  EDIT_JUDICIAL_ERROR,
  RESET_EDIT_JUDICIAL,
} from "../../types/judicial/edit";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_JUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_JUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_JUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_JUDICIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
